import { Redirect } from "../components/Shared";
import { lazy } from "react";

const SignInPage = lazy(() => import("../pages/signin"));
const ClinicalTransactionInfoPage = lazy(() => import("../pages/clinical/transaction"));
const DynamicFormPage = lazy(() => import("../pages/dynamic-form"));

export default function publicRoute() {
  return [
    { path: "/transaction/:transactionId", element: <ClinicalTransactionInfoPage /> },
    { path: "/clinical", element: <DynamicFormPage /> },
    { path: "/dynamic-form", element: <DynamicFormPage /> },
    { path: "/login", element: <SignInPage /> },
    {
      path: "*",
      element: <Redirect to="/login" replace />,
    },
  ];
}